"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
const baseZeroState_1 = require("./baseZeroState");
function channelCardZeroState(channelCardContent, user) {
    const currentDate = new Date().toISOString();
    const { _id: channelCardId, channel: { _id: channelId } } = channelCardContent;
    const { userId, companyId } = user;
    return {
        contentType: entity_1.StateContentType.CHANNEL_CARD,
        userId,
        rootContentId_contentId: `${channelId}_${channelCardId}`,
        companyId,
        contentId: channelCardId,
        rawScore: 0,
        scaledScore: 0,
        progressMeasure: 0,
        scaledProgressMeasure: 0,
        completionStatus: entity_1.CompletionStatus.NOT_ATTEMPTED,
        successStatus: entity_1.SuccessStatus.NOT_APPLICABLE,
        forceComplete: false,
        timeSpent: 0,
        submissionCount: 0,
        lastUpdatedTimeSpent: baseZeroState_1.defaultDate,
        lastSubmittedOn: baseZeroState_1.defaultDate,
        createdAt: currentDate,
        updatedAt: currentDate,
        startedOn: baseZeroState_1.defaultDate,
        lastAccessedOn: baseZeroState_1.defaultDate,
        successOn: baseZeroState_1.defaultDate,
        completedOn: baseZeroState_1.defaultDate,
        contentStatus: 'active',
        accessCount: 0
    };
}
exports.default = channelCardZeroState;
//# sourceMappingURL=channelCardZeroState.js.map